import { render, staticRenderFns } from "./TCVCard.vue?vue&type=template&id=4575743a&ref=main&"
import script from "./TCVCard.vue?vue&type=script&lang=js&"
export * from "./TCVCard.vue?vue&type=script&lang=js&"
import style0 from "./TCVCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports